(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-catalog"]) return;
  try {
    
function initializeWillowCatalog(root) {
  if (root.dataset.swFilterReady) return;
  const controls = root.querySelector('[data-sw-filters]');
  if (!controls) return;
  const cards = Array.from(root.querySelectorAll('.sw-catalog-group [data-product-handle]'));
  const buttons = Array.from(controls.querySelectorAll('[data-sw-topic]'));
  const groups = Array.from(root.querySelectorAll('.sw-catalog-group'));
  const status = controls.querySelector('[data-sw-filter-status]');
  const reset = controls.querySelector('[data-sw-reset]');
  const apply = (topic) => {
    let count = 0;
    cards.forEach((card) => {
      const visible = topic === 'all' || card.dataset.topics.split(' ').includes(topic);
      card.hidden = !visible;
      if (visible) count += 1;
    });
    groups.forEach((group) => {
      group.hidden = !Array.from(group.querySelectorAll('[data-product-handle]')).some((card) => !card.hidden);
      const categoryLink = root.querySelector('.sw-category-nav a[href="#' + group.id + '"]');
      if (categoryLink) categoryLink.hidden = group.hidden;
    });
    buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.swTopic === topic)));
    status.textContent = status.dataset.countTemplate.replace('[count]', String(count));
    reset.hidden = topic === 'all';
  };
  buttons.forEach((button) => {
    button.hidden = button.dataset.swTopic !== 'all' && !cards.some((card) => card.dataset.topics.split(' ').includes(button.dataset.swTopic));
    button.addEventListener('click', () => apply(button.dataset.swTopic));
  });
  reset.addEventListener('click', () => { apply('all'); buttons[0].focus(); });
  controls.hidden = false;
  root.dataset.swFilterReady = 'true';
  const requested = new URLSearchParams(window.location.search).get('focus');
  apply(buttons.some((button) => !button.hidden && button.dataset.swTopic === requested) ? requested : 'all');
}
document.querySelectorAll('.sw-catalog-page').forEach(initializeWillowCatalog);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.sw-catalog-page').forEach(initializeWillowCatalog));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-product"]) return;
  try {
    
function initializeWillowProduct(root) {
  if (root.dataset.swProductReady) return;
  const purchase = root.querySelector('.sw-purchase[id]');
  const bar = root.querySelector('[data-sw-purchase-bar]');
  if (!purchase || !bar || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(([entry]) => {
    bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
  }, { threshold: 0 });
  observer.observe(purchase);
  root.querySelectorAll('[data-sw-return-buy]').forEach((link) => link.addEventListener('click', (event) => {
    event.preventDefault();
    purchase.scrollIntoView({ behavior: 'instant', block: 'start' });
    const button = purchase.querySelector('button[name="add"]');
    if (button) button.focus({ preventScroll: true });
  }));
  root.dataset.swProductReady = 'true';
}
document.querySelectorAll('.sw-product-page').forEach(initializeWillowProduct);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.sw-product-page').forEach(initializeWillowProduct));


  } catch(e) { console.error(e); }
})();
})();
